




import React, { useState, useEffect } from "react";
import { Box, Avatar, useTheme, IconButton } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import BaseCard from "../../../components/Cards/Card";
import CustomText, { textStyles } from "../../../components/CustomText";
import CustomButton from "../../../components/CustomButton";
import MultiSelectionDropdown from "../../../components/MultiSelectionDropdown";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import { useFormik } from "formik";
import { useSelector } from "react-redux";
import { toast, Toaster } from "react-hot-toast";
import CircularProgress from "@mui/material/CircularProgress";
import { BASE_URL } from "../../../components/BaseUrl";
import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";
import AddIcon from "@mui/icons-material/Add"; 
import { showToast } from "../../../Utlis/messageHandler";
import Webcam from "react-webcam";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography
} from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
const CreateProfile = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isLaptop = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const tokenFromModal = location?.state?.profileUpdateToken;

// 2️⃣ existing token sources (UNCHANGED behavior)
const tokenFromRedux = useSelector((s) => s.auth.profileUpdateToken);
const tokenFromStorage = localStorage.getItem("profileUpdateToken");

// 3️⃣ final resolved token (priority-based)
const profileUpdateToken =
  tokenFromModal || tokenFromRedux || tokenFromStorage || null;
  
  // const profileUpdateToken =
  //   useSelector((s) => s.auth.profileUpdateToken) ||
  //   localStorage.getItem("profileUpdateToken");
 console.log("profile token", profileUpdateToken)
  // Avatar state (same pattern as your AddCompanyDrawer)
 
  const [saving, setSaving] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
const openOptions = Boolean(anchorEl);

const handleOpenOptions = (e) => setAnchorEl(e.currentTarget);
const handleCloseOptions = () => setAnchorEl(null);

const [showCamera, setShowCamera] = React.useState(false);
const webcamRef = React.useRef(null);
const [capturedImage, setCapturedImage] = React.useState(null);
const [takingPhoto, setTakingPhoto] = React.useState(false);

const [legalAnchorEl, setLegalAnchorEl] = useState(null);
const openLegalOptions = Boolean(legalAnchorEl);


const [legalCameraMode, setLegalCameraMode] = useState(false);

const openCamera = () => {
  setCapturedImage(null);
  setShowCamera(true);
};


const capturePhoto = async () => {
  if (!webcamRef.current) return;

  const imageSrc = webcamRef.current.getScreenshot();
  if (!imageSrc) {
    toast.error("Failed to capture image");
    return;
  }

  setCapturedImage(imageSrc);
  setTakingPhoto(true);

  try {
    const blob = await fetch(imageSrc).then((res) => res.blob());

    // 🔁 REUSE your existing upload logic
    const uploadedUrl = await uploadToServer(blob, "image");

    if (legalCameraMode) {
      // ✅ Legal document flow
      setLegalDocUrl(uploadedUrl);
      formik.setFieldValue("legal_document_url", uploadedUrl);
      toast.success(t("imageUploadedSuccessfully"));
    } else {
      // ✅ Profile avatar flow (unchanged)
      setAvatarPreview(uploadedUrl);
      formik.setFieldValue("avatar", uploadedUrl);
      toast.success(t("photoCapturedUploaded"));
    }

    setShowCamera(false);
  } catch (err) {
    toast.error(t("uploadFailed"));
  } finally {
    setTakingPhoto(false);
    setLegalCameraMode(false);
  }
};

const handleSelectCamera = () => {
  setAnchorEl(null);
  openCamera();
};

const handleSelectGallery = () => {
  setAnchorEl(null);
  handlePickFile();
};
  // Legal document state
  const legalDocInputRef = React.useRef(null);
  const [legalDocFile, setLegalDocFile] = React.useState(null);
  const [legalDocUrl, setLegalDocUrl] = React.useState("");
  const [uploadingLegalDoc, setUploadingLegalDoc] = React.useState(false);
  
  // Company dropdown state
  const [companies, setCompanies] = useState([]);
  const [loadingCompanies, setLoadingCompanies] = useState(false);
  const [selectedCompanies, setSelectedCompanies] = useState([]);

  // Reuse your upload method logic
  const uploadImageToServer = async (file) => {
    const form = new FormData();
    form.append("image", file); // <-- exact key as your working code

    const res = await fetch(`${BASE_URL}/upload/image`, {
      method: "POST",
      body: form,
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data?.message || "Upload failed");

    // same key picking as your working file
    return data?.data?.url || data?.url || data?.path || "";
  };
const [selectedDocType, setSelectedDocType] = useState(null);
  // Legal document upload function
const uploadToServer = async (file, type) => {
  const form = new FormData();
  if (type === "image") form.append("image", file);
  else form.append("pdf", file);

  const endpoint = type === "image" ? "/upload/image" : "/upload/pdf";

  const res = await fetch(`${BASE_URL}${endpoint}`, {
    method: "POST",
    headers: type === "pdf" ? { Authorization: `Bearer ${profileUpdateToken}` } : undefined,
    body: form,
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data?.message || "Upload failed");

  return data?.data?.url || data?.url || data?.path || "";
};

  const [avatarDataUrl, setAvatarDataUrl] = React.useState(""); // <-- data URL kept here

const handlePickLegalDoc = () => {
  if (legalDocInputRef.current) {
    legalDocInputRef.current.accept = "image/*,.pdf,application/pdf";
    legalDocInputRef.current.click();
  }
}

// Avatar state (same pattern as your AddCompanyDrawer)
const fileInputRef = React.useRef(null);
const [imageFile, setImageFile] = React.useState(null);
const [avatarPreview, setAvatarPreview] = React.useState(""); // URL preview
const [uploadedAvatarUrl, setUploadedAvatarUrl] = React.useState(""); // URL returned from server
const [uploading, setUploading] = React.useState(false);

// Pick file trigger
const handlePickFile = () => fileInputRef.current?.click();
const [showFileTypeDialog, setShowFileTypeDialog] = useState(false);

// Handle image file change (upload to server)
const handleFileChange = async (e) => {
  const file = e.target.files?.[0];
  if (!file) return;

  try {
    setUploading(true);
    setImageFile(file);

    // Upload to server
    const uploadedUrl = await uploadImageToServer(file);
    console.log("✅ Uploaded image URL:", uploadedUrl);
    setUploadedAvatarUrl(uploadedUrl);
    setAvatarPreview(uploadedUrl); // for preview
    formik.setFieldValue("avatar", uploadedUrl); // set URL to Formik field

    toast.success(t("imageUploadedSuccessfully"));
  } catch (err) {
    toast.error(err.message || t("imageUploadFailed"));
    setUploadedAvatarUrl("");
    setAvatarPreview("");
    formik.setFieldValue("avatar", "");
  } finally {
    setUploading(false);
    if (fileInputRef.current) fileInputRef.current.value = "";
  }
};

// Legal document file change handler
const handleLegalDocChange = async (e) => {
  const file = e.target.files?.[0];
  if (!file) return;

  // Detect file type automatically
  const type = file.type.startsWith("image/")
    ? "image"
    : file.type === "application/pdf"
    ? "pdf"
    : null;

  if (!type) {
    toast.error(t("invalidFileType"));
    return;
  }

  try {
    setUploadingLegalDoc(true);
    const uploadedUrl = await uploadToServer(file, type);
    setLegalDocUrl(uploadedUrl);
    formik.setFieldValue("legal_document_url", uploadedUrl);
    console.log("documen is ",uploadedUrl)
    toast.success(`${type.toUpperCase()} ${t("imageUploadedSuccessfully")}`);
  } catch (err) {
    toast.error(err.message || t("uploadFailed"));
    setLegalDocUrl("");
    formik.setFieldValue("legal_document_url", "");
  } finally {
    setUploadingLegalDoc(false);
    if (legalDocInputRef.current) legalDocInputRef.current.value = ""; // reset input
  }
};



const fromRegion = location?.state?.source === "region"; // or however you know
const showErr = (name) =>
  Boolean(formik.errors[name] && (formik.touched[name] || formik.submitCount > 0));
  // Fetch companies on component mount
  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        setLoadingCompanies(true);
        const res = await fetch(`${BASE_URL}/account-executive/companies`, {
          headers: {
            "Content-Type": "application/json",
          },
        });
        const data = await res.json();
        if (res.ok && data.data && data.data.companies) {
          setCompanies(data.data.companies);
        } else {
          toast.error(t("companiesLoadFailed"));
        }
      } catch (error) {
        toast.error(t("companiesLoadError"));
      } finally {
        setLoadingCompanies(false);
      }
    };
    fetchCompanies();
  }, []);

  const formik = useFormik({
    initialValues: {
      firstName: "",
      middleName: "",
      lastName: "",
      avatar: "",   // 👈 NEW (required)
      phone: "",
      dob: "", // date of birth
      // companies: [], // 👈 NEW - array of company IDs
      legal_document_url: "", // 👈 NEW - legal document URL
    },
     validate: (v) => {
    const e = {};

    // Name validation
    if (!v.firstName?.trim()) {
      e.firstName = t("firstNameRequired") || "First name is required";
    }
    if (!v.lastName?.trim()) {
      e.lastName = t("lastNameRequired") || "Last name is required";
    }

    // avatar required
    if (!v.avatar) e.avatar = t("avatarRequired") || "Profile image is required";

    // phone required + numeric + length (10–15 is a safe generic range)
    if (!v.phone) {
      e.phone = t("phoneRequired") || "Phone is required";
    } else if (!/^\d+$/.test(v.phone)) {
      e.phone = t("phoneDigitsOnly") || "Digits only";
    } else if (v.phone.length < 10 || v.phone.length > 15) {
      e.phone = t("phoneInvalid") || "Invalid phone number";
    }

    // date of birth validation (optional but if provided, should be valid date format and age >= 18)
    if (v.dob) {
      const dobDate = new Date(v.dob);
      if (isNaN(dobDate.getTime())) {
        e.dob = t("dobInvalid") || "Invalid date format";
      } else {
        // Calculate age
        const today = new Date();
        let age = today.getFullYear() - dobDate.getFullYear();
        const m = today.getMonth() - dobDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < dobDate.getDate())) {
          age--;
        }
        if (age < 18) {
          e.dob = t("mustBeAtLeast18") || "You must be at least 18 years old";
        }
      }
    }



    return e;
  },
    onSubmit: async (values) => {
      try {
        setSaving(true);
        const url = `${BASE_URL}/account-executive/profile/basic-info`;

        const body = {
          firstName: values.firstName,
          middleName: values.middleName || "",
          lastName: values.lastName,
          phone: values.phone,
          // use the URL we got from upload endpoint (your working flow)
          profilePicture: values.avatar,
          dob: values.dob || null, // date of birth
          // companies: JSON.stringify(values.companies), // 👈 NEW - convert array to JSON string
          legal_document_url: values.legal_document_url, // 👈 NEW - legal document URL
        };
console.log(body)
console.log("🚀 onSubmit Formik values:", values);
        const res = await fetch(url, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${profileUpdateToken}`,
          },
          body: JSON.stringify(body),
        });

        const data = await res.json();
        console.log("response of api of create profile,",data)
        if (!res.ok || data?.error) throw new Error(data?.message || t("somethingWentWrong"));

      
        setTimeout(() => {
          navigate("/location")

        }, 400);
      } catch (err) {
        toast.error(err.message || t("profileCreateFailed"));
      } finally {
        setSaving(false);
      }
    },
  });

  return (
    <Box sx={{ 
      py: { xs: 3, sm: 5, md: 8 }, 
      px: { xs: 1, sm: 2 }, 
      mt: { xs: 5, sm: 2, md: 0 } 
    }}>
      {/* <Toaster /> */}
      <Box sx={{ 
        display: "flex", 
        justifyContent: "center", 
        minHeight: "100vh", 
        alignItems: "center" 
      }}>
        <BaseCard 
          maxWidth={{ 
            xs: "100%", 
            sm: "90%", 
            md: "65%", 
            lg: "50%", 
            xl: "35%" 
          }}
          sx={{
            width: { xs: "100%", sm: "auto" },
            mx: { xs: 1, sm: 0 }
          }}
        >
         

           <Box sx={{ display: "flex", justifyContent: "flex-start", mb: { xs: 2, sm: 3 } }}>
         <Box sx={{ display: "flex", alignItems: "center", gap: { xs: 0.5, sm: 1 } }}>
            <Box sx={{ 
              width: { xs: 20, sm: 25 }, 
              height: { xs: 20, sm: 25 },
              borderRadius: "50%", 
              backgroundColor: theme.palette.primary.main, 
              color: "#fff", 
              display: "flex", 
              justifyContent: "center", 
              alignItems: "center",
              fontSize: { xs: 12, sm: 14 }
            }}>1</Box>
            <Box sx={{ 
              width: { xs: 30, sm: 50, md: 95 }, 
              height: 2, 
              backgroundColor: "#091E4224" 
            }} />
            <Box sx={{ 
              width: { xs: 20, sm: 25 }, 
              height: { xs: 20, sm: 25 },
              borderRadius: "50%", 
              backgroundColor: "#ffffff", 
              color: "#BCBFC2", 
              border: "2px solid #091E4224",
              display: "flex", 
              justifyContent: "center", 
              alignItems: "center",
              fontSize: { xs: 12, sm: 14 }
            }}>2</Box>
           <Box sx={{ 
             width: { xs: 30, sm: 50, md: 95 }, 
             height: 2, 
             backgroundColor: "#091E4224" 
           }} />
           <Box sx={{ 
             width: { xs: 20, sm: 25 }, 
             height: { xs: 20, sm: 25 },
             borderRadius: "50%", 
             backgroundColor: "#ffffff", 
             color: "#BCBFC2",
             border: "2px solid #091E4224", 
             display: "flex", 
             justifyContent: "center", 
             alignItems: "center",
             fontSize: { xs: 12, sm: 14 }
           }}>3</Box>
                        
          </Box>
        </Box>


          <CustomText sx={{ 
            ...textStyles.h4, 
            color: theme.palette.tertiary.main, 
            textAlign: "left", 
            fontSize: { xs: "22px", sm: "24px", md: "26px" }
          }}>
            {t("createProfileTitle")}
          </CustomText>
          <CustomText sx={{ 
            ...textStyles.body5, 
            color: theme.palette.text.primary, 
            pt: { xs: 0.5, sm: 0.7 }, 
            textAlign: "left",
            fontSize: { xs: "14px", sm: "16px" }
          }}>
            {t("createProfileSubtitle")}
          </CustomText>

          {/* Form */}
          <form onSubmit={formik.handleSubmit}>
         
<Box sx={{ mb: 2, mt: 2 }}>
  <label style={{ color: "#626F86", fontSize: "15px" }}>
    {t("profilePicture")} <span style={{ color: "red" }}>*</span>
  </label>

  <Box sx={{ 
    mt: 2, 
    display: "flex", 
    justifyContent: "center", 
    alignItems: "center", 
    gap: { xs: 1, sm: 2 } 
  }}>
    <Box
      sx={{
        position: "relative",
        width: { xs: 120, sm: 150 },
        height: { xs: 120, sm: 150 },
        borderRadius: "50%",
        border: `2px dashed ${showErr("avatar") ? "#d32f2f" : "#091E4224"}`, // 👈 red on error
        display: "grid",
        placeItems: "center",
        cursor: uploading ? "not-allowed" : "pointer",
      }}
      onClick={() => !uploading && handlePickFile()}
      title={uploading ? t("legalDocument.uploading") : t("clickToUpload")}
    >
    <img
     crossOrigin="anonymous"
  src={avatarPreview || undefined}
  // alt="Profile Preview"
  style={{
    width: "120px",
    height: "120px",
    borderRadius: "50%",         // 👈 perfect circle
    objectFit: "cover",           // 👈 ensures image fills circle nicely
    border: "2px solid #ddd",     // optional subtle border
  }}
/>

      <IconButton
        size="small"
        sx={{
          fontSize: "14px",
          position: "absolute",
          top: 1,
          right: 1,
          backgroundColor: "#fff",
          border: "1px solid #ccc",
          boxShadow: 1,
          "&:hover": { backgroundColor: "#f0f0f0" },
        }}
        // onClick={(e) => {
        //   e.stopPropagation();
        //   handlePickFile();
        // }}
        onClick={(e) => {
  e.stopPropagation();
  handleOpenOptions(e);
}}
      >
        <AddIcon fontSize="small" />
      </IconButton>

      {uploading && (
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            display: "grid",
            placeItems: "center",
            backdropFilter: "blur(1px)",
            borderRadius: "50%",
          }}
        >
          <CircularProgress size={28} />
        </Box>
      )}
    </Box>

    <input
      ref={fileInputRef}
      type="file"
      accept="image/*"
      hidden
      onChange={handleFileChange}
    />
  </Box>

  {/* {showErr("avatar") && (
    <Box sx={{ fontSize: 12, color: "#d32f2f", mt: 0.5 }}>
      {formik.errors.avatar}
    </Box>
  )} */}
</Box>

      <Menu anchorEl={anchorEl} open={openOptions} onClose={handleCloseOptions}>
  <MenuItem 
     onClick={handleSelectCamera} 
     sx={{ fontSize: "13px", fontFamily: "Poppins" }}
  >
    {t("takePhoto")}
  </MenuItem>

  <MenuItem 
     onClick={handleSelectGallery} 
     sx={{ fontSize: "13px", fontFamily: "Poppins" }}
  >
    {t("chooseFromGallery")}
  </MenuItem>
</Menu> 


<Menu
  anchorEl={legalAnchorEl}
  open={openLegalOptions}
  onClose={() => setLegalAnchorEl(null)}
>
  <MenuItem
    onClick={() => {
      setLegalAnchorEl(null);
      setLegalCameraMode(true);     // 👈 key line
      setShowCamera(true);
    }}
    sx={{ fontSize: "13px", fontFamily: "Poppins" }}
  >
    {t("takePhoto")}
  </MenuItem>

  <MenuItem
    onClick={() => {
      setLegalAnchorEl(null);
      handlePickLegalDoc();         // 👈 existing flow
    }}
    sx={{ fontSize: "13px", fontFamily: "Poppins" }}
  >
    {t("chooseFromGallery")}
  </MenuItem>
</Menu>



     {/* Name Fields */}
            <Box sx={{ 
              display: "flex", 
              flexDirection: "column",
              gap: { xs: 1.5, sm: 1 }, 
              mb: 2, 
              mt: 2
            }}>
              {/* First and Middle Name Row */}
              <Box sx={{ 
                display: "flex", 
                flexDirection: { xs: "column", sm: "row" }, 
                gap: { xs: 1.5, sm: 1 }
              }}>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <label style={{ color: "#626F86", fontSize: 14 }}>
                    {t("firstName")} <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    name="firstName"
                    value={formik.values.firstName}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className='project_input'
                    style={{
                      height: 38,
                      borderRadius: 6,
                      width: "100%",
                      marginTop: 7,
                      fontSize: 14,
                      border: showErr("firstName")
                        ? "1px solid #d32f2f"
                        : "2px solid #091E4224",
                    }}
                  />
                  {showErr("firstName") && (
                    <span style={{ color: "red", fontSize: 12 }}>
                      {formik.errors.firstName}
                    </span>
                  )}
                </Box>

                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <label style={{ color: "#626F86", fontSize: 14 }}>
                    {t("middleName")}
                  </label>
                  <input
                    name="middleName"
                    className='project_input'
                    value={formik.values.middleName}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    style={{
                      height: 38,
                      borderRadius: 6,
                      width: "100%",
                      marginTop: 7,
                      fontSize: 14,
                      border: showErr("middleName")
                        ? "1px solid #d32f2f"
                        : "2px solid #091E4224",
                    }}
                  />
                  {showErr("middleName") && (
                    <span style={{ color: "red", fontSize: 12 }}>
                      {formik.errors.middleName}
                    </span>
                  )}
                </Box>
              </Box>

              {/* Last Name - Full Width */}
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <label style={{ color: "#626F86", fontSize: 14 }}>
                  {t("lastName")} <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  name="lastName"
                  className='project_input'
                  value={formik.values.lastName}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  style={{
                    height: 38,
                    borderRadius: 6,
                    width: "100%",
                    marginTop: 7,
                    fontSize: 14,
                    border: showErr("lastName")
                      ? "1px solid #d32f2f"
                      : "2px solid #091E4224",
                  }}
                />
                {showErr("lastName") && (
                  <span style={{ color: "red", fontSize: 12 }}>
                    {formik.errors.lastName}
                  </span>
                )}
              </Box>
            </Box>

            <Box sx={{ mb: 2 }}>
              <label style={{ color: "#626F86", fontSize: 14, marginBottom: 7, display: "inline-block" }}>
                {t("phoneNumber")} <span style={{ color: "red" }}>*</span>
              </label>
              <Box
                sx={{
                  // border: "2px solid  #091E4224",
  border: showErr("phone")
      ? "1px solid #d32f2f"   // 👈 red + 1px
      : "2px solid #091E4224",
                  borderRadius: "6px",
                  "& .form-control": {
                    border: "none !important",
                    outline: "none !important",
                    boxShadow: "none !important",
                    width: "100%",
                    height: "40px",
                    fontSize: "14px",
                    paddingLeft: "48px",
                    borderRadius: "6px",
                    fontFamily: "Poppins, sans-serif !important",
                  },
                  "& .flag-dropdown": {
                    border: "none !important",
                    borderRight: "1px solid #ccc !important",
                    backgroundColor: "#f9f9f9",
                    borderTopLeftRadius: "6px",
                    borderBottomLeftRadius: "6px",
                  },
                }}
              >
                <PhoneInput
                countryCodeEditable={false}
                  country={"us"}
                  value={formik.values.phone}
                  onChange={(value) => formik.setFieldValue("phone", value)}
                  inputProps={{ name: "phone", required: true }}
                  containerClass="react-tel-input"
                  inputClass="form-control"
                  buttonClass="flag-dropdown"
                />
              </Box>
              {formik.errors.phone && <Box sx={{ fontSize: 12, color: "red", mt: 0.5 }}>{formik.errors.phone}</Box>}
            </Box>

            {/* Date of Birth */}
            <Box sx={{ mb: 2 }}>
              <label style={{ color: "#626F86", fontSize: 14, marginBottom: 7, display: "inline-block" }}>
                {t("dateOfBirth")} <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="date"
                name="dob"
                value={formik.values.dob}
                // onChange={formik.handleChange}
                  onChange={(e) => {
    const val = e.target.value; // format: yyyy-mm-dd
    const parts = val.split("-");
    if (parts[0] && parts[0].length > 4) {
      parts[0] = parts[0].slice(0, 4); // trim extra digits
    }
    const cleanVal = parts.join("-");
    formik.setFieldValue("dob", cleanVal); // manually set sanitized value
  }}
                onBlur={formik.handleBlur}
                style={{
                  width: "100%",
                  height: "40px",
                  fontSize: "14px",
                  padding: "0 12px",
                  borderRadius: "6px",
                  border: showErr("dob")
                    ? "1px solid #d32f2f"
                    : "2px solid #091E4224",
                  fontFamily: "Poppins, sans-serif",
                  backgroundColor: "#fff",
                  color: "#333",
                }}
              />
              {formik.errors.dob && <Box sx={{ fontSize: 12, color: "red", mt: 0.5 }}>{formik.errors.dob}</Box>}
            </Box>

          
          

            <Box sx={{ mb: 2 }}>
  <label
    style={{
      color: "#626F86",
      fontSize: 14,
      marginBottom: 7,
      display: "inline-block",
    }}
  >
    {t("legalDocument.label")}
 
  </label>

  <Box
    sx={{
      position: "relative",
      border:"2px dashed #091E4224",
      borderRadius: "8px",
      padding: 3,
      textAlign: "center",
      cursor: uploadingLegalDoc ? "not-allowed" : "pointer",
      backgroundColor: legalDocUrl ? "#f0f8f0" : "#fafafa",
      transition: "all 0.2s ease",
      "&:hover": {
        backgroundColor: uploadingLegalDoc ? "#fafafa" : "#f0f0f0",
        borderColor: uploadingLegalDoc
          ? "#091E4224"
          : theme.palette.primary.main,
      },
    }}
    // onClick={() => !uploadingLegalDoc && handlePickLegalDoc()}
    onClick={(e) => {
if (uploadingLegalDoc) return;
setLegalAnchorEl(e.currentTarget);
}}
  >
    {uploadingLegalDoc ? (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 1,
        }}
      >
        <CircularProgress size={24} />
        <CustomText sx={{ fontSize: 14, color: theme.palette.primary.main }}>
          {t("legalDocument.uploading")}
        </CustomText>
      </Box>
    ) : legalDocUrl ? (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 1,
          position: "relative",
        }}
      >
        {/* Remove icon */}
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            setLegalDocUrl(null);
            setLegalDocFile(null);
          }}
          sx={{
            position: "absolute",
            top: 4,
            right: 4,
            bgcolor: "#fff",
            border: "1px solid #ccc",
            "&:hover": { bgcolor: "#f5f5f5" },
            width: 20,
            height: 20,
          }}
        >
          <CloseRoundedIcon sx={{ fontSize: 14 }} />
        </IconButton>

        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: "50%",
            backgroundColor: theme.palette.success.main,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "white",
          }}
        >
          ✓
        </Box>
        <CustomText
          sx={{
            fontSize: 14,
            color: theme.palette.success.main,
            fontWeight: 500,
          }}
        >
          {legalDocFile?.name || t("legalDocument.uploaded")}
        </CustomText>
      </Box>
    ) : (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 1,
        }}
      >
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: "50%",
            backgroundColor: "#f0f0f0",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#666",
          }}
        >
          📄
        </Box>
        <CustomText sx={{ fontSize: 14, color: "#666" }}>
          {/* {t("legalDocument.dragOrBrowse")} */}
          {t("legalDocumentUploadDescription")}
        </CustomText>
        <CustomText sx={{ fontSize: 12, color: "#999" }}>
          {t("legalDocument.maxSize")}
        </CustomText>
      </Box>
    )}
  </Box>

  {/* Note below upload box */}
  <Typography
    sx={{ fontSize: 12, color: "#888", mt: 0.5,     fontFamily: 'Poppins, sans-serif', }}
  >
    {t("validation.onlyImagesAndPdf")}
  </Typography>

  <input
    ref={legalDocInputRef}
    type="file"
    accept="image/*,application/pdf"
    hidden
    onChange={handleLegalDocChange}
  />

  {formik.errors.legal_document_url && (
    <Box sx={{ fontSize: 12, color: "red", mt: 0.5 }}>
      {formik.errors.legal_document_url}
    </Box>
  )}
</Box>



            {/* Avatar */}
                      <Box sx={{ display: "flex",alignItems:"center",justifyContent: "flex-end", mt: 4 }}>

            <CustomButton
              label={
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
                  {(saving) && <CircularProgress size={18} sx={{ color: "#fff" } }/>}
                  {t("next")}
                </Box>
              }
              
              type="submit"
              disabled={saving}
              sx={{ 
                px: { xs: 4, sm: 6 },
                height: { xs: 48, sm: 44 },
                fontSize: { xs: 16, sm: 14 }
              }}
            />
            </Box>
          </form>
        </BaseCard>

{showCamera && (
  <Box
    sx={{
      position: "fixed",
      inset: 0,
      backgroundColor: "rgba(0,0,0,0.6)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1300,
      p: 2,
    }}
  >
    <Box
      sx={{
        backgroundColor: "#fff",
        borderRadius: "16px",
        padding: "24px",
        boxShadow: "0 8px 20px rgba(0,0,0,0.25)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "90%",
        maxWidth: 440,
      }}
    >
      <Box sx={{ width: "100%", textAlign: "center" }}>
        {!capturedImage ? (
          <Webcam
            audio={false}
            ref={webcamRef}
            screenshotFormat="image/jpeg"
            videoConstraints={{ facingMode: "user", width: 400, height: 300 }}
            style={{
              borderRadius: "12px",
              width: "100%",
              maxWidth: "400px",
              objectFit: "cover",
              border: "2px solid #E0E0E0",
            }}
          />
        ) : (
          <img
            src={capturedImage}
            alt="Captured"
            style={{
              borderRadius: "12px",
              width: "100%",
              maxWidth: "400px",
              border: "2px solid #E0E0E0",
            }}
          />
        )}
      </Box>

      <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mt: 3, width: "100%" }}>
        {!capturedImage ? (
          <CustomButton
            label={takingPhoto ? t("uploading") : t("capture")}
            onClick={capturePhoto}
            disabled={takingPhoto}
          />
        ) : (
          <CustomButton
            label={t("retake")}
            onClick={() => setCapturedImage(null)}
          />
        )}

        <CustomButton
          label={t("close")}
          // onClick={() => setShowCamera(false)}
          onClick={() => {
setShowCamera(false);
setLegalCameraMode(false);
}}
          sx={{
            backgroundColor: "#E0E0E0",
            color: "#333",
            "&:hover": { backgroundColor: "#D5D5D5" },
          }}
        />
      </Box>
    </Box>
  </Box>
)}

      </Box>
    </Box>
    
  );
};

export default CreateProfile;












































